import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const DocumentIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "document",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [/* @__PURE__ */ jsx("path", {
			d: "M11.5 4.5V9.5H6.5",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		}), /* @__PURE__ */ jsx("path", {
			d: "M18.5 20.5H6.5V9.5L11.5 4.5H18.5V20.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})]
	});
});
export { DocumentIcon, DocumentIcon as default };

//# sourceMappingURL=Document.js.map